import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { AuctionStatus } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { MinterAuctionsContext } from '../../../Contexts'

const FilterSelect: React.FC = () => {
  const { filter } = useContext(MinterAuctionsContext)

  const { pathname } = useLocation()
  const navigate = useNavigate()
  const page = pathname.split('/')[1]

  const onFilterChange = (event: SelectChangeEvent<string>) => {
    const selection = event.target.value as AuctionStatus
    if (selection) {
      const newPath = `/${page}/${selection}`
      if (pathname !== newPath) {
        navigate(newPath)
      }
    }
  }

  return (
    <Select onChange={onFilterChange} value={filter ?? ''} variant="standard">
      <MenuItem value={AuctionStatus.Available}>Available</MenuItem>
      <MenuItem value={AuctionStatus.Live}>Live</MenuItem>
      <MenuItem value={AuctionStatus.Dutch}>Dutch</MenuItem>
      <MenuItem value={AuctionStatus.Completed}>Completed</MenuItem>
      <MenuItem value={AuctionStatus.Upcoming}>Upcoming</MenuItem>
      <MenuItem value={AuctionStatus.Minted}>Minted</MenuItem>
    </Select>
  )
}

export default FilterSelect
